
<div class="content-dash">
    <div class="title-top"><h1>{{ 'creditCard.title' | translate }}</h1><button ><img src="/assets/icons/plus.svg" alt="">{{ 'creditCard.addButton' | translate }}</button></div>
    

    <app-creditcard-info></app-creditcard-info>

</div>